import shuffle from "./shuffle";

function reversePermutation(permutation) {
	const arr = [];
	for (let i = 0; i < permutation.length; ++i)
		arr[permutation[i]] = i;
	return arr;
}

/**
 * Shuffle paired elements.
 * @param {[[string]]} pairs - array of pairs
 * @return {{ set1: [string], set2: [string], pairs: [[string]] }} two sets of shuffled lines and array of pairs of indices of elements in sets that are in pairs in `pairs`.
 */
export default function shufflePairs(pairs) {
	const range = pairs.map((_, i) => i);
	const perm1 = shuffle([...range]);
	const perm2 = shuffle([...range]);
	const reverse1 = reversePermutation(perm1);
	const reverse2 = reversePermutation(perm2);
	return {
		set1: range.map(i => pairs[perm1[i]][0]),
		set2: range.map(i => pairs[perm2[i]][1]),
		pairs: range.map(i => [reverse1[i], reverse2[i]]),
	};
};